import * as React from 'react';

const VerifiedIconSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={32} height={32} fill="none" {...props}>
        <path fill="#fff" d="M0 0h32v32H0z" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 26.667c5.891 0 10.667-4.776 10.667-10.667S21.89 5.333 16 5.333C10.11 5.333 5.334 10.11 5.334 16S10.109 26.667 16 26.667zm5.596-16l1.888 1.874-9.52 9.452-5.075-5.04 1.888-1.873 3.187 3.165 7.632-7.578z"
            fill="#F05537"
        />
    </svg>
);

VerifiedIconSvg.displayName = 'VerifiedIconSvg';
export default VerifiedIconSvg;
